import React from 'react';
import hospital1 from '../img/hospital-card-1.png';
import hospital2 from '../img/hospital-card-2.png';
import hospital3 from '../img/hospital-card-3.png';
import hospital4 from '../img/hospital-card-4.png';
import { FaChevronRight } from "react-icons/fa6";

const hospitals = [
  {
    id: 1,
    image: hospital1,
    name: "Caritas Hospital",
    address: "Caritas Hospital, Thellakom P.O,  Kottayam  -  686630",
    phone: "0481-2790025 to 29",
    link: "https://caritashospital.org/"
  },
  {
    id: 2,
    image: hospital2,
    name: "Caritas Family Hospital",
    address: "Karipal Building, Vadavathoor P.O, Kalathipady, Kottayam - 686018",
    phone: "0481 2570100",
    link: "https://www.caritasfamilyhospital.com/"
  },
  {
    id: 3,
    image: hospital3,
    name: "Caritas KMM Hospital",
    address: "Kurishupally kavala, Puthenangady, Kottayam, Kerala 686001",
    phone: "0481 2580047",
    link: "https://caritashospital.org/caritaskkm/"
  },
  {
    id: 4,
    image: hospital4,
    name: "Caritas HDP Hospital",
    address: "Caritas HDP Hospital, Kaipuzha, Kottayam , Kerala - 686602",
    phone: "0481 2711418",
    link: "https://caritashospital.org/caritas-hdp-hospital/"
  }
];

const OurHospitals = () => {
  return (
    <section className="our-hospitals-section">
      <div className="container-fluid">
        <h2 className="main-heading">Our Hospitals</h2>
        <p className="our-hospital-section-content">
          Explore our network of outstanding hospitals, each dedicated to delivering <br />comprehensive healthcare with expertise and compassion.
        </p>
        <div className="hospitals-container">
          {hospitals.map(hospital => (
            <div className="our-hospital-card" key={hospital.id}>
              <img src={hospital.image} alt={hospital.name} className="hospital-image"/>
              <h3 className="hospital-name">{hospital.name}</h3>
              <p className="hospital-address">{hospital.address}</p>
              <p className="hospital-phone">{hospital.phone}</p>
              <a href={hospital.link} className="hospital-link">Know more <FaChevronRight /></a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurHospitals;
